import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { MarketExperience } from './marketExperience.component';
import { MarketActions, selectCurrentMarketId } from '../../modules/market';
import { ContentRegistryActions } from '../../modules/contentRegistry';

const mapStateToProps = createStructuredSelector({
  currentMarketId: selectCurrentMarketId,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchMarket: ContentRegistryActions.fetchMarket,
      setCurrentMarketBySlug: MarketActions.setCurrentMarketBySlug,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(MarketExperience);
